import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../../services/encoder';

import { Observable, of } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { SortOrder } from '../models/sortOrder';
import { CAMExceptionRequest } from '../models/cam-exceptions-request';
import { CamException } from '../models/cam-exception';

@Injectable({
  providedIn: 'root',
})
export class CamExceptionService {
  protected basePath = environment.ccdcrp_api_base_url;
  public defaultHeaders = new HttpHeaders();

  constructor(protected httpClient: HttpClient) {}

  /**
   * This API will fetch count of CAM
   *
   * @param paginationPageNumber
   * @param paginationPageSize
   * @param paginationSortOrder
   * @param paginationSortColumn
   * @param customerConsigneeName
   * @param rutConsignee
   * @param scvCustomerCode
   * @param exceptionType
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public camExceptionsCountGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    customerConsigneeName?: string,
    rutConsignee?: string,
    scvCustomerCode?: string,
    exceptionType?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<number>;
  public camExceptionsCountGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    customerConsigneeName?: string,
    rutConsignee?: string,
    scvCustomerCode?: string,
    exceptionType?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<HttpResponse<number>>;
  public camExceptionsCountGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    customerConsigneeName?: string,
    rutConsignee?: string,
    scvCustomerCode?: string,
    exceptionType?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<HttpEvent<number>>;
  public camExceptionsCountGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    customerConsigneeName?: string,
    rutConsignee?: string,
    scvCustomerCode?: string,
    exceptionType?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (paginationPageNumber !== undefined && paginationPageNumber !== null) {
      queryParameters = queryParameters.set(
        'Pagination.PageNumber',
        <any>paginationPageNumber
      );
    }
    if (paginationPageSize !== undefined && paginationPageSize !== null) {
      queryParameters = queryParameters.set(
        'Pagination.PageSize',
        <any>paginationPageSize
      );
    }
    if (paginationSortOrder !== undefined && paginationSortOrder !== null) {
      queryParameters = queryParameters.set(
        'Pagination.SortOrder',
        <any>paginationSortOrder
      );
    }
    if (paginationSortColumn !== undefined && paginationSortColumn !== null) {
      queryParameters = queryParameters.set(
        'Pagination.SortColumn',
        <any>paginationSortColumn
      );
    }

    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<number>(
      'get',
      `${this.basePath}/cam-chile/get-records-count`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will fetch list of FEA Tariffs
   *
   * @param paginationPageNumber
   * @param paginationPageSize
   * @param paginationSortOrder
   * @param paginationSortColumn
   * @param customerConsigneeName
   * @param rutConsignee
   * @param scvCustomerCode
   * @param exceptionType
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public camExceptionsGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    customerConsigneeName?: string,
    rutConsignee?: string,
    scvCustomerCode?: string,
    exceptionType?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<CAMExceptionRequest>>;
  public camExceptionsGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    customerConsigneeName?: string,
    rutConsignee?: string,
    scvCustomerCode?: string,
    exceptionType?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<CAMExceptionRequest>>>;
  public camExceptionsGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    customerConsigneeName?: string,
    rutConsignee?: string,
    scvCustomerCode?: string,
    exceptionType?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<CAMExceptionRequest>>>;
  public camExceptionsGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    customerConsigneeName?: string,
    rutConsignee?: string,
    scvCustomerCode?: string,
    exceptionType?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (paginationPageNumber !== undefined && paginationPageNumber !== null) {
      queryParameters = queryParameters.set(
        'Pagination.PageNumber',
        <any>paginationPageNumber
      );
    }
    if (paginationPageSize !== undefined && paginationPageSize !== null) {
      queryParameters = queryParameters.set(
        'Pagination.PageSize',
        <any>paginationPageSize
      );
    }
    if (paginationSortOrder !== undefined && paginationSortOrder !== null) {
      queryParameters = queryParameters.set(
        'Pagination.SortOrder',
        <any>paginationSortOrder
      );
    }
    if (paginationSortColumn !== undefined && paginationSortColumn !== null) {
      queryParameters = queryParameters.set(
        'Pagination.SortColumn',
        <any>paginationSortColumn
      );
    }
    if (customerConsigneeName !== undefined && customerConsigneeName !== null) {
      queryParameters = queryParameters.set(
        'customerConsigneeName',
        <any>customerConsigneeName
      );
    }
    if (rutConsignee !== undefined && rutConsignee !== null) {
      queryParameters = queryParameters.set('rutConsignee', <any>rutConsignee);
    }
    if (scvCustomerCode !== undefined && scvCustomerCode !== null) {
      queryParameters = queryParameters.set(
        'scvCustomerCode',
        <any>scvCustomerCode
      );
    }
    if (exceptionType !== undefined && exceptionType !== null) {
      queryParameters = queryParameters.set(
        'exceptionType',
        <any>exceptionType
      );
    }

    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<CAMExceptionRequest>>(
      'get',
      `${this.basePath}/cam-chile/get-records`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Upload CAM records for a given fileId
   * @param fileId Id of the uploaded file
   * @param idToken Optional authentication token
   * @returns Observable<boolean>
   */
  public uploadCAMRecords(
    fileId: number,
    idToken?: string
  ): Observable<boolean>;
  public uploadCAMRecords(
    fileId: number,
    idToken?: string
  ): Observable<HttpResponse<boolean>>;
  public uploadCAMRecords(
    fileId: number,
    idToken?: string
  ): Observable<HttpEvent<boolean>>;
  public uploadCAMRecords(fileId: number, idToken?: string): Observable<any> {
    if (fileId === null || fileId === undefined || fileId <= 0) {
      throw new Error(
        'Required parameter fileId was null, undefined, or invalid.'
      );
    }

    let headers = this.defaultHeaders;
    if (idToken) {
      headers = headers.set('Id-Token', idToken);
    }

    // Accept header
    headers = headers.set('Accept', 'application/json');

    // Query param
    const params = new HttpParams().set('fileId', fileId.toString());

    // POST request (no body)
    return this.httpClient.post<boolean>(
      `${this.basePath}/cam-chile/upload-cam-records`,
      null, // no body
      {
        headers,
        params,
        observe: 'body', // default, can be overridden if needed
        reportProgress: false,
      }
    );
  }
}
